module.exports = __webpack_public_path__ + "img/serialnum.5bb8350e.svg";